module.exports = __webpack_public_path__ + "img/badge-network-silver-darkbg.cfc1ca34.svg";